export default __webpack_public_path__ + "static/media/Linkedin Learning SQL Programing.a28c083b.webp";